module.exports = __webpack_public_path__ + "img/37.8d295681.jpg";